<div class="login-container">
  <div class="auth-language-switch" role="group" [attr.aria-label]="'LOGIN.LANGUAGE_SWITCH' | translate">
    <button nz-button nzType="link" type="button" [class.active]="selectedLanguage === 'de'" (click)="switchLanguage('de')">DE</button>
    <button nz-button nzType="link" type="button" [class.active]="selectedLanguage === 'en'" (click)="switchLanguage('en')">EN</button>
  </div>
  <form *ngIf="!isResetPasswordMode && !isSignupMode && !isMfaMode" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="auth-header">
      <div class="auth-title">{{ 'LOGIN.TITLE' | translate }}</div>
      <div class="auth-subtitle">
        {{ 'LOGIN.NEW_HERE' | translate }}
        <button nz-button nzType="link" type="button" class="inline-link" (click)="openSignupFromLogin()">
          {{ 'LOGIN.CREATE_ACCOUNT_LINK' | translate }}
        </button>
      </div>
    </div>
    <nz-form-item>
      <nz-form-label nzFor="email">{{ 'LOGIN.EMAIL' | translate }}</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="email" id="email" placeholder="{{ 'LOGIN.EMAIL_PLACEHOLDER' | translate }}" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzFor="password">{{ 'LOGIN.PASSWORD' | translate }}</nz-form-label>
      <nz-form-control>
        <div class="password-input-wrapper">
          <input
            nz-input
            [type]="passwordVisible ? 'text' : 'password'"
            formControlName="password" id="password" placeholder="{{ 'LOGIN.PASSWORD_PLACEHOLDER' | translate }}" />
          <button
            class="password-visibility-toggle"
            type="button"
            [attr.aria-label]="'LOGIN.PASSWORD' | translate"
            (click)="togglePasswordVisibility()"
          >
            <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"></i>
          </button>
        </div>
      </nz-form-control>
    </nz-form-item>
    <div class="signup-suggestion" *ngIf="showSignupSuggestion">
      <div class="signup-suggestion-title">{{ 'LOGIN.SIGNUP_SUGGESTION_TITLE' | translate }}</div>
      <div class="signup-suggestion-desc">{{ 'LOGIN.SIGNUP_SUGGESTION_DESC' | translate }}</div>
      <button nz-button nzType="primary" type="button" (click)="openSignupFromLogin()">
        {{ 'LOGIN.CREATE_ACCOUNT_BUTTON' | translate }}
      </button>
    </div>
    <div class="login-actions">
      <button
        nz-button
        nzType="primary"
        [disabled]="!loginForm.valid || isSubmittingLogin"
        type="submit"
      >
        <nz-spin *ngIf="isSubmittingLogin" nzSize="small"></nz-spin>
        <span *ngIf="!isSubmittingLogin">{{ 'LOGIN.SUBMIT' | translate }}</span>
      </button>
      <button nz-button nzType="default" type="button" (click)="openSignupFromLogin()">
        {{ 'LOGIN.CREATE_ACCOUNT_BUTTON' | translate }}
      </button>
<!--      <button nz-button nzType="default" (click)="loginWithMicrosoft()">{{ 'LOGIN.MICROSOFT_LOGIN' | translate }}</button>-->
    </div>
    <!-- Toggle to Reset Password Mode -->
    <div class="login-links">
      <a (click)="toggleResetPasswordMode(true)">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a>
    </div>
  </form>

  <section *ngIf="isShowingRecoveryCodes" class="mfa-setup">
    <div class="auth-header">
      <div class="auth-title">{{ 'LOGIN.MFA_RECOVERY_CODES_TITLE' | translate }}</div>
      <div class="auth-subtitle">{{ 'LOGIN.MFA_RECOVERY_CODES_WARNING' | translate }}</div>
    </div>
    <ul><li *ngFor="let recoveryCode of mfaRecoveryCodes"><code>{{ recoveryCode }}</code></li></ul>
    <div class="login-actions"><button nz-button nzType="primary" type="button" (click)="continueAfterRecoveryCodes()">{{ 'LOGIN.MFA_RECOVERY_CODES_CONTINUE' | translate }}</button></div>
  </section>

  <form *ngIf="isMfaMode && !isShowingRecoveryCodes" [formGroup]="mfaForm" (ngSubmit)="submitMfa()">
    <div class="auth-header">
      <div class="auth-title">{{ 'LOGIN.MFA_TITLE' | translate }}</div>
      <div class="auth-subtitle">{{ (mfaState === 'recovery_verify' || useRecoveryCode ? 'LOGIN.MFA_RECOVERY_PROMPT' : 'LOGIN.MFA_PROMPT') | translate }}</div>
    </div>
    <ng-container *ngIf="mfaState === 'initial_enrollment' || mfaState === 'replacement_enrollment' || mfaState === 'recovery_enrollment'">
      <nz-form-item *ngIf="mfaState === 'initial_enrollment' && !mfaManualKey">
        <nz-form-label nzFor="mfa-bootstrap">{{ 'LOGIN.MFA_BOOTSTRAP' | translate }}</nz-form-label>
        <nz-form-control>
          <input nz-input id="mfa-bootstrap" type="password" autocomplete="one-time-code" formControlName="bootstrapCredential" />
        </nz-form-control>
      </nz-form-item>
      <div *ngIf="mfaManualKey" class="mfa-setup">
        <img *ngIf="mfaQrCode" [src]="mfaQrCode" [alt]="'LOGIN.MFA_QR_ALT' | translate" />
        <p>{{ 'LOGIN.MFA_MANUAL_KEY' | translate }}: <code>{{ mfaManualKey }}</code></p>
      </div>
    </ng-container>
    <nz-form-item *ngIf="mfaManualKey || mfaState === 'verify' || mfaState === 'recovery_verify'">
      <nz-form-label nzFor="mfa-code">{{ 'LOGIN.MFA_CODE' | translate }}</nz-form-label>
      <nz-form-control>
        <input nz-input id="mfa-code" type="text" autocomplete="one-time-code" formControlName="code" />
      </nz-form-control>
    </nz-form-item>
    <div class="login-links" *ngIf="mfaState === 'verify'">
      <a *ngIf="!useRecoveryCode" (click)="switchMfaMethod(true)">{{ 'LOGIN.MFA_USE_RECOVERY_CODE' | translate }}</a>
      <a *ngIf="useRecoveryCode" (click)="switchMfaMethod(false)">{{ 'LOGIN.MFA_USE_AUTHENTICATOR' | translate }}</a>
    </div>
    <div class="login-actions">
      <button nz-button nzType="primary" [disabled]="isSubmittingMfa" type="submit">
        <nz-spin *ngIf="isSubmittingMfa" nzSize="small"></nz-spin>
        <span *ngIf="!isSubmittingMfa">{{ (mfaManualKey ? 'LOGIN.MFA_CONFIRM' : 'LOGIN.MFA_CONTINUE') | translate }}</span>
      </button>
    </div>
  </form>

  <!-- Signup Form -->
  <form *ngIf="isSignupMode && !isVerifyingCode" [formGroup]="signupForm" (ngSubmit)="onSignup()">
    <div class="direct-registration-header">
      <div class="auth-title">{{ 'SIGNUP.DIRECT_TITLE' | translate }}</div>
      <div class="signup-benefits" role="list">
        <div class="signup-benefit" role="listitem">
          <i nz-icon nzType="check-circle" nzTheme="twotone"></i>
          <span>{{ 'SIGNUP.BENEFIT_PROPERTIES' | translate }}</span>
        </div>
        <div class="signup-benefit" role="listitem">
          <i nz-icon nzType="check-circle" nzTheme="twotone"></i>
          <span>{{ 'SIGNUP.BENEFIT_CARD' | translate }}</span>
        </div>
        <div class="signup-benefit" role="listitem">
          <i nz-icon nzType="check-circle" nzTheme="twotone"></i>
          <span>{{ 'SIGNUP.BENEFIT_READY' | translate }}</span>
        </div>
      </div>
    </div>
    <nz-form-item>
      <nz-form-label>{{ 'SIGNUP.COMPANY_NAME' | translate }}</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          formControlName="companyName"
          id="signup-company"
          placeholder="{{ 'SIGNUP.COMPANY_PLACEHOLDER' | translate }}"
        />
      </nz-form-control>
    </nz-form-item>
<!--    <nz-form-item>-->
<!--      <nz-form-label>{{ 'SIGNUP.APP_MODE_LABEL' | translate }}</nz-form-label>-->
<!--      <nz-form-control>-->
<!--        <nz-radio-group formControlName="appMode">-->
<!--          <label nz-radio nzValue="emergency">{{ 'SIGNUP.APP_MODE_EMERGENCY' | translate }}</label>-->
<!--          <label nz-radio nzValue="hospitality">{{ 'SIGNUP.APP_MODE_HOSPITALITY' | translate }}</label>-->
<!--        </nz-radio-group>-->
<!--      </nz-form-control>-->
<!--    </nz-form-item>-->
    <nz-form-item>
      <nz-form-label>{{ 'SIGNUP.EMAIL' | translate }}</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          formControlName="email"
          id="signup-email"
          placeholder="{{ 'SIGNUP.EMAIL_PLACEHOLDER' | translate }}"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label>{{ 'SIGNUP.PASSWORD' | translate }}</nz-form-label>
      <nz-form-control>
        <div class="password-input-wrapper">
          <input
            nz-input
            [type]="signupPasswordVisible ? 'text' : 'password'"
            formControlName="password"
            id="signup-password"
            placeholder="{{ 'SIGNUP.PASSWORD_PLACEHOLDER' | translate }}"
          />
          <button
            class="password-visibility-toggle"
            type="button"
            [attr.aria-label]="'SIGNUP.PASSWORD' | translate"
            (click)="toggleSignupPasswordVisibility()"
          >
            <i nz-icon [nzType]="signupPasswordVisible ? 'eye-invisible' : 'eye'"></i>
          </button>
        </div>
        <div class="password-strength-meter" *ngIf="signupForm.get('password')?.value">
          <div class="strength-bar" [ngClass]="passwordStrength"></div>
          <div class="strength-label" [ngClass]="passwordStrength">
            {{ 'SIGNUP.STRENGTH_' + passwordStrength.toUpperCase() | translate }}
          </div>
        </div>
        <div
          *ngIf="signupForm.get('password')?.invalid && signupForm.get('password')?.dirty"
          class="error-text"
          [ngClass]="signupForm.get('password')?.value ? passwordStrength : 'weak'"
        >
          <ul>
            <li *ngIf="signupForm.get('password')?.errors?.['required']">{{ 'SIGNUP.PASSWORD_REQUIRED' | translate }}</li>
            <li *ngIf="signupForm.get('password')?.errors?.['minlength']">{{ 'SIGNUP.PASSWORD_MIN_LENGTH' | translate }}</li>
            <li *ngIf="signupForm.get('password')?.errors?.['pattern']">{{ 'SIGNUP.PASSWORD_COMPLEXITY' | translate }}</li>
            <li *ngIf="signupForm.get('password')?.errors?.['passwordTooLong']">{{ 'SIGNUP.PASSWORD_TOO_LONG' | translate }}</li>
          </ul>
        </div>
      </nz-form-control>
    </nz-form-item>
    <div class="terms-acknowledgment">
      <label nz-checkbox formControlName="termsAccepted">
        {{ 'SIGNUP.TERMS_ACCEPT_PREFIX' | translate }}
        <a
          [href]="termsUrl"
          target="_blank"
          rel="noopener noreferrer"
          (click)="$event.stopPropagation()"
        >{{ 'SIGNUP.TERMS_LINK' | translate }}</a>{{ 'SIGNUP.TERMS_ACCEPT_SUFFIX' | translate }}
      </label>
      <div class="error-text" *ngIf="signupForm.get('termsAccepted')?.invalid && signupForm.get('termsAccepted')?.touched">
        {{ 'SIGNUP.TERMS_REQUIRED' | translate }}
      </div>
    </div>
    <div class="login-actions">
      <button
        nz-button
        nzType="primary"
        [disabled]="!signupForm.valid || isSubmittingSignup"
        type="submit"
      >
        <nz-spin *ngIf="isSubmittingSignup" nzSize="small"></nz-spin>
        <span *ngIf="!isSubmittingSignup">{{ 'SIGNUP.SUBMIT' | translate }}</span>
      </button>
    </div>

    <div class="login-links">
<!--      <a (click)="toggleSignupMode(false)">{{ 'SIGNUP.BACK_TO_LOGIN' | translate }}</a>-->
      <a (click)="backToLogin()">{{ 'SIGNUP.BACK_TO_LOGIN' | translate }}</a>
    </div>
  </form>

  <!-- Code Verification Form -->
  <form *ngIf="isVerifyingCode" [formGroup]="codeForm" (ngSubmit)="onVerifyCode()">
    <div class="verification-meta">
      <div class="sent-to">
        {{ 'SIGNUP.CODE_SENT_TO' | translate:{ email: signupEmail } }}
      </div>

      <div class="verification-links">
        <button nz-button nzType="link" type="button" (click)="editSignupDetails()">
          {{ 'SIGNUP.CHANGE_EMAIL' | translate }}
        </button>

        <button
          nz-button
          nzType="link"
          type="button"
          (click)="resendSignupCode()"
          [disabled]="isSubmittingResend || isResendCooldownActive"
        >
          <nz-spin *ngIf="isSubmittingResend" nzSize="small"></nz-spin>

          <span *ngIf="!isSubmittingResend && !isResendCooldownActive">
            {{ 'SIGNUP.RESEND_CODE' | translate }}
          </span>

          <span *ngIf="!isSubmittingResend && isResendCooldownActive">
            {{ 'SIGNUP.RESEND_IN' | translate:{ seconds: resendCooldownSeconds } }}
          </span>
        </button>
      </div>
    </div>

    <nz-form-item>
      <nz-form-label>{{ 'SIGNUP.VERIFICATION_CODE' | translate }}</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          formControlName="code"
          placeholder="{{ 'SIGNUP.CODE_PLACEHOLDER' | translate }}"
          type="tel"
          maxlength="6"
          pattern="[0-9]*"
        />
      </nz-form-control>
    </nz-form-item>
    <div class="login-actions">
      <button
        nz-button
        nzType="primary"
        [disabled]="!codeForm.valid || isSubmittingVerify"
        type="submit"
      >
        <nz-spin *ngIf="isSubmittingVerify" nzSize="small"></nz-spin>
        <span *ngIf="!isSubmittingVerify">{{ 'SIGNUP.VERIFY' | translate }}</span>
      </button>
    </div>
  </form>

<!--  &lt;!&ndash; Add Sign Up link &ndash;&gt;-->
<!--  <div class="login-links" *ngIf="!isSignupMode && !isResetPasswordMode">-->
<!--    <a (click)="toggleSignupMode(true)">{{ 'SIGNUP.NO_ACCOUNT' | translate }}</a>-->
<!--  </div>-->

  <!-- Reset Password Form -->
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPasswordSubmit()" *ngIf="isResetPasswordMode">
    <nz-form-item>
      <nz-form-label nzFor="email">{{ 'LOGIN.RESET_PASSWORD_EMAIL' | translate }}</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="email" id="reset-email" placeholder="{{ 'LOGIN.RESET_PASSWORD_ENTER_EMAIL' | translate }}" />
      </nz-form-control>
    </nz-form-item>
    <div class="login-actions">
      <button
        nz-button
        nzType="primary"
        [disabled]="!resetPasswordForm.valid || isSubmittingReset"
        type="submit"
      >
        <nz-spin *ngIf="isSubmittingReset" nzSize="small"></nz-spin>
        <span *ngIf="!isSubmittingReset">{{ 'LOGIN.RESET_PASSWORD_SUBMIT' | translate }}</span>
      </button>

    </div>
    <!-- Toggle back to Login Mode -->
    <div class="login-links">
      <a (click)="toggleResetPasswordMode(false)">{{ 'LOGIN.BACK_TO_LOGIN' | translate }}</a>
    </div>
  </form>
  <div class="marketing-link">
    <a href="https://scanafy.de/" target="_blank" rel="noopener">
      {{ 'LOGIN.VISIT_WEBSITE' | translate }}
    </a>
  </div>
</div>
